<markant-platform-ui-card
  class="management-tile"
  [headline]="'cartridge.management.eligibleUser.title' | transloco"
>
  <p class="actions-section-text">
    {{ 'cartridge.management.eligibleUser.info' | transloco }}
  </p>
  <div footer>
    <a
      class="link"
      [routerLink]="[variantId, 'employees']"
      [state]="{ bookingState, usageRightState }"
    >
      {{ 'cartridge.management.eligibleUser.action' | transloco }}
      <markant-icon class="link-icon" icon="m_arrow-right-small"></markant-icon>
    </a>
  </div>
</markant-platform-ui-card>
